import { mapState } from "vuex";
export default {
    computed: {
        ...mapState([ 'user', ]),
        showApplications() {
            return this.user && (this.user.applications_count||0) > 0;
        },
        showRequests() {
            return this.user && (this.user.requests_count||0) > 0;
        },
    },
    methods: {
        getSettings(requestForApproval) {
            return JSON.parse(requestForApproval.settings||'{"permissions":1,"need_approve":true,"submission":1,"instructions":""}');
        },
        hasPending(requestForApproval, forApplication, forManager) {
            if(typeof forApplication == 'undefined') { forApplication = false; }
            if(typeof forManager == 'undefined') { forManager = false; }
            return forApplication || forManager ? this.getSettings(requestForApproval).need_approve ? requestForApproval.reviewers_count === 0 : requestForApproval.form_required_completed === 0 : requestForApproval.form_required_completed === 0 && !(moment(requestForApproval.date_approved).isValid() || moment(requestForApproval.date_disapproved).isValid());
        },
        hasExpired(requestForApproval, forApplication, forManager) {
            return this.hasPending(requestForApproval, forApplication, forManager) && moment(requestForApproval.course_end_date).isValid() && moment(requestForApproval.course_end_date).isBefore(moment(), 'hour');
        },
    },
};